import { ColumnDef } from "@tanstack/react-table";
import { Spinner } from "@win-reality/react-ui";
import { Link } from "react-router-dom";

import { type Complex } from "@/types/game";

import { ComplexHealth } from "./components/ComplexHealth";

export const complexesColumns: ColumnDef<Complex>[] = [
  {
    accessorKey: "name",
    header: "Complex Name",
    size: 200,
    enableSorting: true,
    cell: ({ row: { original: row } }) => (
      <Link
        to={`/manage-smartparks/complex/${row.name}`}
        className="flex flex-col"
      >
        <span className="text-sm text-blue">{row.name}</span>
        <span className="text-xs text-gray-500">{row.location}</span>
      </Link>
    ),
  },
  {
    id: "activeEvents",
    header: "Active",
    accessorKey: "activeEventsCount",
    size: 65,
    enableSorting: true,
    cell: ({ row: { original: row } }) => {
      return <span className="text-sm">{row.activeEventsCount}</span>;
    },
  },
  {
    id: "scheduledEvents",
    header: "Scheduled",
    accessorKey: "scheduledEventsCount",
    size: 85,
    enableSorting: true,
    cell: ({ row: { original: row } }) => {
      return (
        <span className="text-sm">
          {row.scheduledEventsCount === undefined ? (
            <Spinner className="h-3.5 w-3.5 align-middle" />
          ) : (
            row.scheduledEventsCount
          )}
        </span>
      );
    },
  },
  {
    id: "fieldCount",
    header: "Fields",
    accessorKey: "fields",
    size: 65,
    enableSorting: true,
    cell: ({ row: { original: row } }) => (
      <span className="text-sm">{row.fieldCount}</span>
    ),
  },
  {
    accessorKey: "health",
    header: () => {
      return <div>Complex Health</div>;
    },
    meta: { headerClassName: "justify-end" },
    enableSorting: false,
    cell: ({ row: { original: row } }) => (
      <div className="light flex justify-end w-full">
        <ComplexHealth fields={row.fields} complexName={row.name} />
      </div>
    ),
  },
];
